import { fetchPath } from '..'
import yodaFormatter from '../yodaFormatter'

export const createBasket = ({ contactIri, currencyCode }) => fetchPath.run({
  path: '/yoda/api/baskets',
  method: 'POST',
  data: {
    contact: contactIri,
    currencyCode,
  },
  jsonPath: ['content', 'data'],
}).then((data) => ({
  ...yodaFormatter(data),
  basketLines: [],
}))

export const loadContactBasket = async (contactId, { loadLines = true } = {}) => {
  const basket = await fetchPath.run({
    path: `/yoda/api/contacts/${contactId}/current-basket`,
    jsonPath: ['content', 'data'],
  }).then(yodaFormatter)

  if (loadLines) {
    const basketLines = await fetchPath.run({
      path: '/yoda/api/basket-lines',
      parameters: {
        basket: basket.id,
        itemsPerPage: 999,
      },
      jsonPath: ['content', 'data'],
    }).then((basketLines) => basketLines.map(yodaFormatter))

    return {
      ...basket,
      basketLines,
    }
  }
  return basket
}

export const submitBasket = async ({ id }, offerIds) => fetchPath.run({
  path: `/yoda/api/baskets/${id}/submit`,
  parameters: { offers: offerIds },
  method: 'PUT',
})

export const createBasketLine = (data) => fetchPath.run({
  path: '/yoda/api/basket-lines',
  method: 'POST',
  data,
  jsonPath: ['content', 'data'],
}).then(yodaFormatter)

export const deleteBasketLine = ({ id }) => (
  fetchPath.run({
    path: `/yoda/api/basket-lines/${id}`,
    method: 'delete',
  })
)

export const unitPriceNegotiationFormatter = (negotiation) => {
  const data = yodaFormatter(negotiation)

  return {
    ...data,
    created: new Date(data.created),
    unitPrice: parseInt(data.unitPrice, 10),
  }
}

export const createUnitPriceNegotiation = (priceRequestData) => (
  fetchPath.run({
    path: '/yoda/api/unit-price-negotiations',
    method: 'post',
    data: priceRequestData,
    jsonPath: ['content', 'data'],
  }).then(unitPriceNegotiationFormatter)
)

export const replaceUnitPriceNegotiation = (priceRequestIdentifier) => {
  let priceRequestId = priceRequestIdentifier

  if (typeof priceRequestIdentifier === 'string') {
    const [, id] = /(?:\/api\/unit-price-negotiations\/)?(\d+)/.exec(priceRequestIdentifier)
    priceRequestId = parseInt(id, 10)
  }

  return fetchPath.run({
    path: `/yoda/api/unit-price-negotiations/${priceRequestId}/replace`,
    method: 'put',
    jsonPath: ['content', 'data'],
  }).then(unitPriceNegotiationFormatter)
}

export default {
  createBasket,
  loadContactBasket,
  submitBasket,
  createBasketLine,
  createUnitPriceNegotiation,
  replaceUnitPriceNegotiation,
  unitPriceNegotiationFormatter,
  deleteBasketLine,
}
